export default "__VITE_ASSET__c3ba429a__"